import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function PeopleIcon({ size = 26, color }: { size?: number; color?: string }) {
    return (
        <Svg width={size} height={size} viewBox="0 0 36 36" fill="none">
            <Path
                d="M25.587 12.296a1.076 1.076 0 00-.307 0 4.191 4.191 0 01-4.054-4.2 4.217 4.217 0 014.215-4.214 4.217 4.217 0 014.214 4.214c-.014 2.275-1.808 4.127-4.069 4.2zM30.34 22.403c-1.632 1.093-3.922 1.502-6.037 1.225.555-1.196.846-2.523.86-3.923 0-1.459-.32-2.844-.933-4.054 2.159-.292 4.448.116 6.096 1.21 2.304 1.517 2.304 4.01.015 5.542zM9.414 12.296c.102-.014.204-.014.306 0a4.191 4.191 0 004.054-4.2 4.207 4.207 0 00-4.215-4.214 4.204 4.204 0 00-4.2 4.214 4.191 4.191 0 004.055 4.2zM9.574 19.705c0 1.414.306 2.756.86 3.966-2.056.22-4.2-.218-5.775-1.254-2.304-1.531-2.304-4.025 0-5.556 1.56-1.05 3.763-1.473 5.834-1.24a9.272 9.272 0 00-.92 4.084zM17.697 24.109a1.657 1.657 0 00-.38 0 4.995 4.995 0 01-4.826-5.002 5.029 5.029 0 015.031-5.017 5.016 5.016 0 015.017 5.017c-.015 2.712-2.144 4.914-4.842 5.002zM12.957 27.128c-2.202 1.473-2.202 3.893 0 5.352 2.509 1.677 6.621 1.677 9.13 0 2.201-1.473 2.201-3.894 0-5.352-2.494-1.677-6.607-1.677-9.13 0z"
                fill={color || '#F78437'}
            />
        </Svg>
    );
}

export default PeopleIcon;
